/**
 * VariantsPage — all forks and mirrors across all modules.
 */

import { useGallery } from '../state/gallery-store';
import { Link } from 'react-router-dom';
import './VariantsPage.css';

export function VariantsPage() {
  const { registry, stats } = useGallery();

  if (!registry) return null;

  const allVariants: Array<{
    moduleId: string;
    type: 'mirror' | 'fork';
    owner: string;
    path: string;
    state: string;
    overridePercent?: number;
    forkReason?: string | null;
  }> = [];

  for (const [moduleId, variants] of Object.entries(registry.variant_index)) {
    for (const v of variants) {
      allVariants.push({
        moduleId,
        type: v.type,
        owner: v.owner,
        path: v.path,
        state: v.state,
        overridePercent: v.override_percent,
        forkReason: v.fork_reason,
      });
    }
  }

  return (
    <div className="variants-page">
      <header className="variants-page__header">
        <h1 className="variants-page__title">Variants</h1>
        <span className="variants-page__count">{allVariants.length}</span>
      </header>
      <p className="variants-page__intro">
        Forks, mirrors, and customisations of canonical modules.
        Mirrors are byte-identical to canonical. Forks have been customised.
        Heavy forks (50%+ override) trigger the heavy-fork rules per FVW §10.3.
      </p>

      {allVariants.length === 0 ? (
        <p className="variants-page__empty">
          No variants yet. {stats && stats.total_modules > 0 ? (
            <>Try forking a module — once a fork is registered, it appears here.</>
          ) : null}
        </p>
      ) : (
        <table className="variants-page__table">
          <thead>
            <tr>
              <th>Module</th>
              <th>Type</th>
              <th>Owner</th>
              <th>State</th>
              <th>Override</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {allVariants.map((v) => (
              <tr key={v.path}>
                <td>
                  <Link to={`/modules/${v.moduleId}`}>{v.moduleId}</Link>
                </td>
                <td>
                  <span className={`variants-page__type variants-page__type--${v.type}`}>
                    {v.type}
                  </span>
                </td>
                <td><code>{v.owner}</code></td>
                <td><code>{v.state}</code></td>
                <td>
                  {v.overridePercent !== undefined
                    ? `${v.overridePercent.toFixed(0)}%`
                    : '—'}
                </td>
                <td>{v.forkReason ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
